import { Pipe, PipeTransform } from '@angular/core';
import { LocationStatus } from '../models/locations';
import { LocationIconClass } from '../constants/location-icon.constants';
import { feat_TodoItemFlatNode } from '../../homemapdashboard/location-feature-property-list/location-feature-property-list.component';

@Pipe({
    name: 'locationIconClass',
})
export class LocationIconClassPipe implements PipeTransform {
    /**
     * Get the icon CSS class based on location status and alarm properties
     * Following the same logic as mapStyle.constant.ts getMonitorColor function
     */
    transform(node: feat_TodoItemFlatNode): string {
        if (!node?.feature) {
            return LocationIconClass.NORMAL;
        }

        const status = node.feature.get('Status');
        const alarmId = node.feature.get('AlarmId');
        const acknowledgedBy = node.feature.get('AcknowledgedBy');

        // Default to normal (green)
        let locationIconClass = LocationIconClass.NORMAL;

        // Check for inactive/maintenance status first
        if (status === LocationStatus.Inactive || status === LocationStatus.InactiveRemoved) {
            locationIconClass = LocationIconClass.INACTIVE;
        } else if (status === LocationStatus.Maintenance) {
            locationIconClass = LocationIconClass.MAINTENANCE;
        }

        // Check for alarm conditions (overrides status)
        if (alarmId) {
            if (acknowledgedBy) {
                locationIconClass = LocationIconClass.WARNING; // acknowledged alarm (orange)
            } else {
                locationIconClass = LocationIconClass.ALARM; // unacknowledged alarm (red)
            }
        }

        return locationIconClass;
    }
}
